import React, {PureComponent} from 'react';
import {FastField, FieldArray, ErrorMessage} from 'formik';
import get from 'lodash/get';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../../res/translations/messages';
import FormRow from '../FormRow';
import ExclusiveImageChoiceType from '../ExclusiveImageChoiceType';
import FormGroup from '../FormGroup';
import CommonFields from './CommonFields';
import Error from '../../../Error';
import {IMAGE_RATIO_FORMATS} from '../../../../constants';

class MultipleChoice2Type extends PureComponent {
    constructor(props) {
        super(props);
        this.onMinUpdate = this.onMinUpdate.bind(this);
        this.onMaxUpdate = this.onMaxUpdate.bind(this);
    }

    onMinUpdate(e) {
        const {name, form} = this.props;
        const intVal = parseInt(e.currentTarget.value) || 0;
        // this is needed or the value won't be updated to the field
        form.setFieldValue(`${name}.min`, intVal > 0 ? intVal : '');
    }

    onMaxUpdate(e) {
        const {name, form} = this.props;
        const intVal = parseInt(e.currentTarget.value) || 0;
        // this is needed or the value won't be updated to the field
        form.setFieldValue(`${name}.max`, intVal > 0 ? intVal : '');
    }

    render() {
        const {name, form, previousPages} = this.props;

        return (
            <>
                <CommonFields name={name} form={form} required={true} previousPages={previousPages} />
                <div className="row">
                    <FormGroup name={`${name}.ratio`} size={12} label={messages.surveys.form.label.ratio}>
                        <FastField id={`${name}.ratio`} name={`${name}.ratio`} component="select"
                            className={classNames('form-control custom-select',
                                {error: get(form.errors, `${name}.ratio`) && get(form.touched, `${name}.ratio`)})}>
                            {IMAGE_RATIO_FORMATS.map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}
                        </FastField>
                        <ErrorMessage name={`${name}.ratio`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                    </FormGroup>
                </div>
                <FormRow name={`${name}.min`} label={messages.surveys.form.label.min} size={3}>
                    <FastField id={`${name}.min`} name={`${name}.min`} type="number" step="any" onChange={this.onMinUpdate}
                        className={classNames('form-control',
                            {error: get(form.errors, `${name}.min`) && get(form.touched, `${name}.min`)})} />
                    <ErrorMessage name={`${name}.min`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                </FormRow>
                <FormRow name={`${name}.max`} label={messages.surveys.form.label.max} size={3}>
                    <FastField id={`${name}.max`} name={`${name}.max`} type="number" step="any" onChange={this.onMaxUpdate}
                        className={classNames('form-control',
                            {error: get(form.errors, `${name}.max`) && get(form.touched, `${name}.max`)})} />
                    <ErrorMessage name={`${name}.max`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                </FormRow>
                <div className="form-group">
                    <h4>
                        &gt; <FormattedMessage {...messages.surveys.form.label.optionList} />
                    </h4>
                    <FieldArray name={`${name}.choices`} component={ExclusiveImageChoiceType} />
                    <ErrorMessage name={`${name}.choices`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                </div>
            </>
        );
    }
}

export default MultipleChoice2Type;
